import { render, staticRenderFns } from "./AlunoClasse.vue?vue&type=template&id=574dd7fa&"
import script from "./AlunoClasse.vue?vue&type=script&lang=js&"
export * from "./AlunoClasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports